import { Outlet, useLocation } from 'react-router-dom';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { usePageViewTracking } from '@/hooks/usePageViewTracking';
import { useSiteConfig } from '@/context/SiteConfigContext';

export const SiteLayout = () => {
  const location = useLocation();
  const isPostRoute = /^\/posts\/[^/]+$/.test(location.pathname);
  const { config, isLoading } = useSiteConfig();

  usePageViewTracking({
    enabled: !isPostRoute && !isLoading,
    entryOnly: config.analytics.entryOnly,
    requireUtm: config.analytics.requireUtm,
  });

  return (
    <div className="site-shell">
      <Header />
      <main className="site-main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};
